import { browser } from '$app/env';
import type { RemoteQuery } from '$app/server';

/**
 * Await a remote query, re-fetching it if SvelteKit already holds a cached
 * value. TanStack Query owns caching for these calls (polling, focus refetch,
 * invalidation), so it must always get fresh data, which is what SvelteKit
 * 2's `.run()` did. On the server each request has its own cache, so a plain
 * await is enough.
 */
export const freshQuery = async <T>(query: RemoteQuery<T>): Promise<T> => {
  if (browser && query.ready) {
    await query.refresh();
  }
  return await query;
};
